import Hero, { LayoutsPageHeroProps } from './parts/hero';
import Content, { LayoutsPageContentProps } from './parts/content';

import classnames from 'classnames';
import styles from './page.module.scss';
import { resolveClassNames } from '../../../helpers/classes';
import { ViewportStyles } from '../../../global/types/viewport.type';

export type LayoutsPageProps = {
  children: React.ReactNode;
  className?: string | Array<string>;
  style?: ViewportStyles; // contextStyle type
};

export type { LayoutsPageHeroProps, LayoutsPageContentProps };

const Page = ({
  children,
  style = { mobile: {} },
  className,
}: LayoutsPageProps) => (
  <div
    className={classnames(styles.page, resolveClassNames(className, styles))}
    style={context.handleStyle(style)}
  >
    {children}
  </div>
);

Page.displayName = 'Page';
Page.Hero = Hero;
Page.Content = Content;

export default Page;
